export default __webpack_public_path__ + "static/dairy-free-taste-3-desktop-5e51e8fdb4500d8ffde8f5993807e45d.png";